<template>
<div class="bg-transparent ai-response-occupation-outer ai-overflow-y d-flex flex-wrap" style="position: relative;">
    <div class="ai-category-accordion-body">
        <div class="ai-response-profile-card no-box-shadow border-radius-10 border-radius-10 mb-3 mr-2" v-for="(aidata, i) in occupationAIText" :key="i">
            <div class="ai-response-profile-card-header">
                <h2>{{ aidata.title }}</h2>
            </div>
            <div class="ai-response-profile-card-body">
                <div class="ai-response-profile-card-body-content mt-2" v-for="( insights, j ) in aidata.detail" :key="j">
                    <h3>
                        {{ insights.title }}
                    </h3>
                    <ul class="ai-response-profile-list mt-2">
                        <li>
                        {{ insights.detail }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import occupationData from '../CareerFit/occupation';
export default {
  name: "career-fit-occupation",
    props: {
        title:String
    },
    data() {
        return {
            occupationAIText:[],
            occupationAILoad:false
        }
    },
    async mounted(){
    try {
     
        console.log(this.title)   
    } catch (error) {
        console.log(this.title);
        
    }
      this.occupationAILoad = true;
      this.occupationAIText = [];
      const result = await this.$http.post(
        "https://admin.spendid.io/api/get-occupation-data",
        { req: [this.title] }
      );
      // const jsonArray = JSON.parse(jsonString);
      this.occupationAILoad = false;
      this.occupationAIText = result.data.result;
        
    },  
    watch: {
        title(newVal, oldVal) {
            console.log("Prop changed from", oldVal, "to", newVal);
        }
    }
};
</script>
<style scoped>
    /* .ai-response-occupation-outer {
        max-height: 500px;
        overflow: auto;
    } */
</style>
